export function objectIsEmpty(obj: Record<string, any>) {
  return Object.keys(obj).length === 0;
}
